import React from 'react';

import Checkbox from 'src/shared/components/checkbox/Checkbox';

/** Header checkbox reflects eligible rows only (assignable + not disabled by limits) */
export type ColumnSelectAllState = 'checked' | 'unchecked' | 'indeterminate';

type ColumnSelectAllCheckboxProps = {
    state: ColumnSelectAllState;
    onToggle: () => void;
    ariaLabel: string;
    disabled: boolean;
    className?: string;
};

/** Maps tri-state to `Checkbox` checked + indeterminate for role column “select all” */
const ColumnSelectAllCheckbox = ({ state, onToggle, ariaLabel, disabled, className }: ColumnSelectAllCheckboxProps) => {
    return (
        <Checkbox
            checked={state === 'checked'}
            indeterminate={state === 'indeterminate'}
            disabled={disabled}
            ariaLabel={ariaLabel}
            checkboxClassName={className}
            onChange={() => onToggle()}
        />
    );
};

export default ColumnSelectAllCheckbox;
